<template>
    <div class="tags">
        <tag
            v-for="(tag, key) in value"
            :key="key"
            class="tags__item"
            :label="tag"
        ></tag>
    </div>
</template>

<script>
import Tag from "./Tag";

export default {
    components: {Tag},
    props: {
        value: {type: Array}
    }
}
</script>

<style lang="scss">
.tags {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .tags__item {
        height: 18px;
        padding: 0 8px;
        margin-right: 5px;
        margin-top: 1px;
        margin-bottom: 1px;
        font-size: 11px;

        &:last-child {
            margin-right: 0;
        }
    }
}
</style>